module.exports = __webpack_public_path__ + "media/src/img/flag_of_kyrgyzstan_like_kz_proportion-0cfad8bf96b1289f49570baf2a31a80f.svg";